/***
 *
 *   REQUEST A CHANGE
 *   The support modal the Workflows page opens from "Request a change" and
 *   "Talk to a workflow engineer". It follows the help page's support form
 *   (views/dashboard/help.js) and posts to the same /api/support/ticket.
 *
 *   Every modal key is passed explicitly: hiding the modal doesn't clear
 *   form, callback or destructive, so a stale one would otherwise ride along.
 *   article_slug is always '' because the ticket prints any slug as a
 *   help-site link; the workflow goes in article_title, and the message
 *   starts with "Workflow: <title>" so the ticket subject names it.
 *
 **********/

export function requestChangeModal(triggerTitle) {
  const title = triggerTitle || null;

  return {
    title: "Request a change",
    text: "Your message goes straight to our support team, who will reply by email. A StackGo workflow engineer will confirm the change and any cost before anything is updated.",
    form: {
      article_slug: {
        type: "hidden",
        value: "",
      },
      article_title: {
        type: "hidden",
        value: title || "Workflows",
      },
      message: {
        type: "textarea",
        label: "What can we help with?",
        required: true,
        errorMessage: "Please enter a message",
        value: `Workflow: ${title || "All workflows"}\n\nWhat I'd like changed:\n`,
      },
    },
    url: "/api/support/ticket",
    method: "POST",
    buttonText: "Send Message",
    destructive: false,
  };
}
